import { Positions } from '../@types/SettingSpace';

export const positions: Positions[] = ['top', 'right', 'bottom', 'left'];
